var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgElem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    height: 869,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-43.6 -10.2 2060.2 869.0",
    width: 2060.2,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312.472656 221.320312 C 252.136719 261.804688 195.253906 307.328125 142.785156 357.421875 C 86.296875 411.347656 33.304688 472.964844 10.699219 547.722656 C -43.644531 727.445312 118.460938 852.628906 283.800781 847.789062 C 428.449219 843.550781 563.652344 805.148438 707.738281 799.167969 C 889.84375 791.601562 1056.738281 813.199219 1236.683594 828.433594 C 1595.621094 858.828125 2016.589844 499.457031 1671.773438 174.707031 C 1486.847656 0.550781 1181.84375 -10.171875 943.050781 4.953125 C 718.820312 19.152344 499.125 96.082031 312.472656 221.320312",
    fill: "#0e486d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElem3);
export default __webpack_public_path__ + "static/media/bg-elem-3.c1d4ef9c9a1a6033e9ceb191888db8c1.svg";
export { ForwardRef as ReactComponent };